import React, { FC, useState } from "react";
import { Field, FormRenderProps, useFormState } from "react-final-form";
import { Link, makeStyles } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import PasswordInput from "../../../../../components/PasswordInput";
import Loading from "../../../../../components/Loading";
import { mutateErrors } from "../../../../../utils";
import { NotifyMode } from "../../../../notify/NotifyModeEnum";
import { useAuth } from "../../../../auth/hooks/useAuth";
import { useNotify } from "../../../../notify/useNotify";
import { useWizard } from "../../../../wizard/context";
import useUserQueries from "../../../hooks/useUserQueries";

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: "100%",
    height: 305,
    "& > div:last-child": {
      marginTop: 24,
      marginBottom: -2,
    },
  },
  linkContainer: {
    marginTop: 15,
    marginBottom: 15,
  },
  link: {
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    marginLeft: -15,
    color: "#2f80ed",
    "&:hover": {
      color: "#1368d8",
    },
  },
}));

const ChangePasswordForm: FC<FormRenderProps> = ({ handleSubmit }) => {
  const classes = useStyles();
  const {
    user: { email },
    logout,
  } = useAuth();
  const { openWizard } = useWizard();
  const snackNotify = useNotify();
  const [isLoading, setIsLoading] = useState(false);
  const { resetPassword } = useUserQueries();
  const {
    values: { closeWizard },
  } = useFormState();

  const forgotPasswordClickHandler = async (email) => {
    try {
      setIsLoading(true);
      await resetPassword({ email });

      setIsLoading(false);

      await openWizard({
        steps: [
          {
            titleConfig: {
              titleText: "Almost There",
            },
            content: "Please, check your mail",
          },
        ],
        submitButtonText: "Ok",
        cancelButtonText: null,
      });

      closeWizard(null);
      logout();
    } catch (e) {
      setIsLoading(false);
      const { message } = mutateErrors(e);
      snackNotify("Error", message, NotifyMode.ERROR);
    }
  };

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.mainContainer}>
        {isLoading && <Loading />}
        <Field
          required
          fullWidth
          type="password"
          name="old_password"
          label="Current Password"
          placeholder="Current Password"
          component={PasswordInput}
        />
        <ListItem className={classes.linkContainer}>
          <Link
            href="#"
            className={classes.link}
            onClick={(evt) => {
              evt.preventDefault();
              forgotPasswordClickHandler(email);
            }}
          >
            Forgot Password
          </Link>
        </ListItem>
        <Field
          required
          fullWidth
          type="password"
          name="password"
          label="New Password"
          placeholder="New Password"
          component={PasswordInput}
        />
        <Field
          required
          fullWidth
          type="password"
          name="password_confirmation"
          label="Confirm New Password"
          placeholder="Confirm New Password"
          component={PasswordInput}
        />
      </div>
    </form>
  );
};

export default ChangePasswordForm;
